import Page from 'src/model/page';
import { appLogger } from 'app-lib/helpers/logging';
const logger = appLogger.create('page tracker');
let lastPage = Page.EXTERNAL;

export default class PageTracker {
    static set lastPage(name) {
        if (!(Page.values().includes(name))) {
            logger.debug('Cannot set last page for name that isn\'t a part of the valid page names');
            return;
        }
        lastPage = name;
    }

    static get lastPage() {
        return lastPage;
    }
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/page-tracker.js